import React from 'react';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import { format } from 'date-fns';

ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

interface Reading {
  id: string | number;
  date: string;
  daily_kwh: number;
  total_kwh: number;
}

interface ReadingsChartProps {
  readings: Reading[];
}

const ReadingsChart: React.FC<ReadingsChartProps> = ({ readings }) => {
  // Sort readings by date (newest first)
  const sortedReadings = [...readings].sort(
    (a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()
  );

  const data = {
    labels: sortedReadings.map(r => {
      const date = new Date(r.date);
      // Show day of week, day number, and month abbreviation
      return format(date, 'EEE') + '\n' + format(date, 'd') + ' ' + format(date, 'MMM');
    }),
    datasets: [
      {
        label: 'Daily kWh',
        data: sortedReadings.map(r => r.daily_kwh),
        backgroundColor: '#16A34A',
        borderColor: '#16A34A',
        borderWidth: 1,
      }
    ]
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        display: false
      },
      title: {
        display: false
      }
    },
    scales: {
      x: {
        ticks: {
          font: {
            size: window.innerWidth < 640 ? 10 : 12
          }
        }
      },
      y: {
        beginAtZero: true,
        max: 30,
        ticks: {
          stepSize: 5,
          font: {
            size: window.innerWidth < 640 ? 10 : 12
          }
        }
      }
    }
  };

  return (
    <div className="bg-white p-3 sm:p-6 rounded-lg shadow-sm">
      <div className="h-64 sm:h-80 md:h-96">
        <Bar data={data} options={options} />
      </div>
    </div>
  );
};

export default ReadingsChart;
